import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { VIOLATIONS_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_VIOLATION_LIST = '_LOAD_VIOLATION_LIST';
export const CREATE_VIOLATION = '_CREATE_VIOLATION';
export const LOAD_VIOLATION_BY_ID = '_LOAD_VIOLATION_BY_ID';
export const EDIT_VIOLATION_BY_ID = '_EDIT_VIOLATION_BY_ID';
export const DELETE_VIOLATION = '_DELETE_VIOLATION';
export const GENERATE_VIOLATION_PROTOCOL_PDF = '_GENERATE_VIOLATION_PROTOCOL_PDF';

export const loadViolationList = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST);
export const loadViolationListBegin = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST + BEGIN);
export const loadViolationListSuccessful = createAction(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST + SUCCESSFUL);
export const loadViolationListFailed = createAction(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST + FAILED);

export const createViolation = createDeferredAction(VIOLATIONS_MODULE + CREATE_VIOLATION);
export const createViolationSuccessful = createAction(VIOLATIONS_MODULE + CREATE_VIOLATION + SUCCESSFUL);
export const createViolationFailed = createAction(VIOLATIONS_MODULE + CREATE_VIOLATION + FAILED);

export const loadViolationById = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID);
export const loadViolationByIdSuccessful = createAction(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID + SUCCESSFUL);
export const loadViolationByIdFailed = createAction(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID + FAILED);
export const loadViolationByIdClear = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID + CLEAR);

export const editViolationById = createDeferredAction(VIOLATIONS_MODULE + EDIT_VIOLATION_BY_ID);
export const editViolationByIdSuccessful = createAction(VIOLATIONS_MODULE + EDIT_VIOLATION_BY_ID + SUCCESSFUL);
export const editViolationByIdFailed = createAction(VIOLATIONS_MODULE + EDIT_VIOLATION_BY_ID + FAILED);

export const deleteViolation = createDeferredAction(VIOLATIONS_MODULE + DELETE_VIOLATION);
export const deleteViolationSuccessful = createAction(VIOLATIONS_MODULE + DELETE_VIOLATION + SUCCESSFUL);
export const deleteViolationFailed = createAction(VIOLATIONS_MODULE + DELETE_VIOLATION + FAILED);

export const generateViolationProtocolPdf = createDeferredAction(VIOLATIONS_MODULE + GENERATE_VIOLATION_PROTOCOL_PDF);
export const generateViolationProtocolPdfSuccessful = createAction(VIOLATIONS_MODULE + GENERATE_VIOLATION_PROTOCOL_PDF + SUCCESSFUL);
export const generateViolationProtocolPdfFailed = createAction(VIOLATIONS_MODULE + GENERATE_VIOLATION_PROTOCOL_PDF + FAILED);
